<script setup lang="ts">
import { usePlayerFlagsStore } from '@/stores/playerFlagsStore.ts'
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import Alert from '@/components/Elements/Alerts/Alert.vue'
import TutorialFrame from '@/components/Interface/Modal/Modals/Tutorial/TutorialFrame.vue'
import GenericIcon from '@/components/Elements/Images/Icons/GenericIcon.vue'
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { handleNext } from '../tutorialSteps'

const playerFlagsStore = usePlayerFlagsStore()
const route = useRoute()
const router = useRouter()

const handleNextStep = async () => {
  await handleNext('tutorial_diplomacy')
}

const isOnDiplomacySection = computed(() => {
  return route.path.startsWith('/diplomacy')
})

const goToDiplomacy = () => {
  router.push('/diplomacy')
}
</script>

<template>
  <TutorialFrame
    video-url="https://cdn.ferion.com/videos/advisors/temperate/government.webm"
  >
    <template #text>
      <p class="pb-2">
        Here on the diplomacy section you can see all known civilizations, their relationship status with you, and more.
      </p>
      <p class="pb-2">
        The planet and ship information you see here comes from your active scanners, so most likely these are not always 100% accurate.
      </p>
      <p class="pb-2">
        On this page you can request Non aggression Pacts, declare war etc.
      </p>
    </template>

    <template #alerts>
      <Alert type="info">
        Click on the name of the new civilization you have just met, if you are up to it, request to be friends.
      </Alert>
    </template>

    <template #buttons>
      <ActionButton v-if="!isOnDiplomacySection" @click="goToDiplomacy" class="mr-2">
        Go to Diplomacy
      </ActionButton>
      <ActionButton @click="handleNextStep">
        Understood!
      </ActionButton>
    </template>
  </TutorialFrame>
</template>

<style scoped lang="scss">

</style>